import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getMunicipio, setMunicipio } from "../services/data";

export function useMunicipioFromUrl() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const municipioFromUrl = searchParams.get("municipio");

    if (municipioFromUrl) {
      const currentMunicipio = getMunicipio();
      if (currentMunicipio !== municipioFromUrl) {
        setMunicipio(municipioFromUrl);
      }
    } else {
      const storedMunicipio = getMunicipio();
      if (storedMunicipio && storedMunicipio !== "municipio") {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("municipio", storedMunicipio);
        setSearchParams(newParams, { replace: true });
      }
    }
  }, [searchParams, setSearchParams]);

  const buildUrlWithMunicipio = (basePath: string, additionalParams?: Record<string, string>): string => {
    const municipio = searchParams.get("municipio") || getMunicipio();
    const params = new URLSearchParams();

    if (municipio && municipio !== "municipio") {
      params.set("municipio", municipio);
    }

    if (additionalParams) {
      Object.entries(additionalParams).forEach(([key, value]) => {
        params.set(key, value);
      });
    }

    const queryString = params.toString();
    return queryString ? `${basePath}?${queryString}` : basePath;
  };

  const getMunicipioQueryParam = (): string => {
    const municipio = searchParams.get("municipio") || getMunicipio();
    if (municipio && municipio !== "municipio") {
      return `municipio=${encodeURIComponent(municipio)}`;
    }
    return "";
  };

  return {
    municipio: searchParams.get("municipio") || getMunicipio(),
    buildUrlWithMunicipio,
    getMunicipioQueryParam,
  };
}

export function syncMunicipioFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  const municipioFromUrl = params.get("municipio");

  if (municipioFromUrl) {
    setMunicipio(municipioFromUrl);
  }
}

export function appendMunicipioToUrl(url: string): string {
  const municipio = getMunicipio();
  if (!municipio || municipio === "municipio") {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}municipio=${encodeURIComponent(municipio)}`;
}
